import api from '../../utils/api';
import { EncounterReasonType } from 'types/encounterManagement';

const authEndpoint: string = `${process.env.REACT_APP_ENDPOINT}/encounter/reasons`;
const fetchAll = () => {
  return api.get(`${authEndpoint}`);
};

const create = (data: EncounterReasonType) => {
  return api.post(`${authEndpoint}`, data);
};

const update = (id: number, data: EncounterReasonType) => {
  return api.put(`${authEndpoint}/${id}`, data);
};

const destroy = (id: number) => {
  return api.delete(`${authEndpoint}/${id}`);
};

export default {
  fetchAll,
  create,
  update,
  destroy
};
